import styled from "styled-components";

export const TextArea = styled.textarea.attrs({
  className: "appearance-none rounded h-15 focus:outline-none px-5 py-2",
})`
  width: 100%;
  border: 1px solid #ece6ee;
  ::placeholder {
    color: lightgray;
  }
`;
